import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Toolbar } from 'primereact/toolbar';

import { AspirationStats } from '@/components';

type Props = {
  saving: boolean;
  readyToSave: boolean;
  saveBlockedReason: string;
  aspirationInfoLoading: boolean;
  onSave: () => void;
  onCancel: () => void;
  showAspirationStats: boolean;
  setShowAspirationStats: (v: boolean) => void;
  statsDisabled: boolean;
  opuDate: string;
  opuSiteId: string;
};

export const AspirationToolbar = ({
  saving,
  readyToSave,
  saveBlockedReason,
  aspirationInfoLoading,
  onSave,
  onCancel,
  showAspirationStats,
  setShowAspirationStats,
  statsDisabled,
  opuDate,
  opuSiteId,
}: Props) => {
  return (
    <Toolbar
      className="aspiration-form__toolbar"
      start={
        <div className="aspiration-save-buttons">
          <Button
            icon="pi pi-times"
            label="Cancel"
            type="button"
            severity="secondary"
            className="save"
            onClick={onCancel}
          />
          <Button
            icon="pi pi-check"
            label="Save"
            type="button"
            className="save"
            disabled={saving || !readyToSave}
            loading={saving || aspirationInfoLoading}
            onClick={onSave}
            tooltip={!readyToSave ? saveBlockedReason : undefined}
            tooltipOptions={{ position: 'bottom' }}
          />
        </div>
      }
      end={
        <>
          <Button
            severity="secondary"
            label="Aspiration Stats"
            type="button"
            icon="pi pi-eye"
            onClick={() => setShowAspirationStats(true)}
            className="show-aspiration-stats"
            disabled={statsDisabled}
          />
          {showAspirationStats && (
            <Dialog
              header="Aspiration Stats"
              visible={showAspirationStats}
              onHide={() => setShowAspirationStats(false)}
              footer={
                <div>
                  <Button
                    severity="secondary"
                    label="Close"
                    icon="pi pi-times"
                    onClick={() => setShowAspirationStats(false)}
                  />
                </div>
              }
            >
              <AspirationStats
                aspirationDate={opuDate}
                siteId={opuSiteId as string}
              />
            </Dialog>
          )}
        </>
      }
    />
  );
};
